import type {
  CashFlowSettingsConfiguration,
  CashFlowValue,
  DrillDownInfo,
} from "../../../../../../../api/types/svTypes.ts";

export type CashFlowMode = CashFlowSettingsConfiguration["displayMode"];
export interface CashFlowRow {
  id: string;
  date: string;
  calculationDate?: string;
  amount: number;
  amountFormatted: string;
  label: string;
  kind: "Total" | "Transaction" | "Nav";
  expandable: boolean;
  dimensions?: Record<string, string>;
  drillDownInfo?: DrillDownInfo;
  entryNo?: string;
}

export const buildCashFlowRows = (values: CashFlowValue[], mode: CashFlowMode, totalLabel: string): CashFlowRow[] => {
  return values.flatMap((value, index) => {
    if (value.isIrr) {
      return [];
    }
    const id = String(index);
    const transactions = value.transactions ?? [];
    const row: CashFlowRow = {
      id,
      date: value.date,
      amount: value.amount,
      amountFormatted: value.amountFormatted,
      label: value.isNav ? (value.isBeginningOfPeriod ? "Beginning NAV" : "Ending NAV") : totalLabel,
      kind: value.isNav ? "Nav" : "Total",
      expandable: !value.isNav && transactions.length > 0,
      drillDownInfo: value.drillDownInfo,
    };
    if (value.isNav) {
      return [row];
    }
    const details: CashFlowRow[] = transactions.map((transaction, item) => ({
      ...transaction,
      id: `${id}/${item}`,
      calculationDate: value.date,
      kind: "Transaction",
      label: "",
      expandable: false,
    }));
    if (mode === "Details") {
      return details.length > 0 ? details : [row];
    }
    return mode === "Summary" ? [row] : [row, ...details];
  });
};
